import { Navigate, Route, Routes, useLocation } from 'react-router';
import { AuthProvider, useAuth } from './lib/AuthContext';
import AppShell from './layout/AppShell';
import LoginPage from './pages/LoginPage';
import AuthCallbackPage from './pages/AuthCallbackPage';
import DashboardPage from './pages/DashboardPage';
import AbteilungenPage from './pages/AbteilungenPage';
import BenutzerPage from './pages/BenutzerPage';
import ImportPage from './pages/ImportPage';
import ZuordnungenPage from './pages/ZuordnungenPage';
import UmsatzsteuerPage from './pages/UmsatzsteuerPage';
import KstPage from './pages/KstPage';
import BudgetruecklagePage from './pages/BudgetruecklagePage';
import EuerPage from './pages/EuerPage';
import LiquiditaetPage from './pages/LiquiditaetPage';

export function RequireAuth({ children }: { children: React.ReactElement }) {
  const { loading, idToken } = useAuth();
  const location = useLocation();
  if (loading) return null;
  // Das Ziel mitgeben, damit ein Link nach der Anmeldung dort ankommt, nicht auf der Startseite.
  if (!idToken) {
    return <Navigate to="/login" replace state={{ from: location.pathname + location.search }} />;
  }
  return children;
}

export default function App() {
  return (
    <AuthProvider>
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route path="/auth/callback" element={<AuthCallbackPage />} />
        <Route
          element={
            <RequireAuth>
              <AppShell />
            </RequireAuth>
          }
        >
          <Route path="/" element={<Navigate to="/dashboard" replace />} />
          <Route path="/dashboard" element={<DashboardPage />} />
          <Route path="/umsatzsteuer" element={<UmsatzsteuerPage />} />
          <Route path="/kst" element={<KstPage />} />
          <Route path="/budgetruecklage" element={<BudgetruecklagePage />} />
          <Route path="/euer" element={<EuerPage />} />
          <Route path="/liquiditaet" element={<LiquiditaetPage />} />
          <Route path="/abteilungen" element={<AbteilungenPage />} />
          <Route path="/benutzer" element={<BenutzerPage />} />
          <Route path="/import" element={<ImportPage />} />
          <Route path="/zuordnungen" element={<ZuordnungenPage />} />
        </Route>
        <Route path="*" element={<Navigate to="/login" replace />} />
      </Routes>
    </AuthProvider>
  );
}
